"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreauthAdjustmentBanner = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_i18next_1 = require("react-i18next");
const formatAmount = (value, currency) => `${value.toFixed(2)} ${currency}`;
const formatSignedAmount = (value, currency) => {
    const sign = value < 0 ? '−' : '';
    return `${sign}${Math.abs(value).toFixed(2)} ${currency}`;
};
const PreauthAdjustmentBanner = ({ adjustment, currency = 'EUR', }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const stats = [
        {
            label: t('exceedsPreauth.orderAmount'),
            value: formatAmount(adjustment.originalAmount, currency),
        },
        {
            label: t('exceedsPreauth.preauthLimit'),
            value: formatAmount(adjustment.preauthLimit, currency),
        },
        {
            label: t('exceedsPreauth.chargedAmount'),
            value: formatAmount(adjustment.chargedAmount, currency),
        },
        {
            label: t('exceedsPreauth.difference'),
            value: formatSignedAmount(adjustment.adjustmentAmount, currency),
        },
    ];
    return ((0, jsx_runtime_1.jsxs)("div", { role: "status", "aria-live": "polite", "data-testid": "preauth-adjustment-banner", className: "flex items-start gap-3 rounded-lg border-l-4 border-amber-500 bg-amber-50 p-4 text-amber-900", children: [(0, jsx_runtime_1.jsx)("i", { className: "pi pi-exclamation-triangle mt-0.5 text-xl text-amber-600", "aria-hidden": "true" }), (0, jsx_runtime_1.jsxs)("div", { className: "flex-1", children: [(0, jsx_runtime_1.jsx)("p", { className: "text-base font-semibold", children: t('exceedsPreauth.detailBannerTitle') }), (0, jsx_runtime_1.jsx)("p", { className: "mt-1 text-sm text-amber-800", children: t('exceedsPreauth.detailBannerDescription') }), (0, jsx_runtime_1.jsx)("dl", { className: "mt-2 flex flex-wrap gap-x-6 gap-y-1 text-sm", children: stats.map(({ label, value }) => ((0, jsx_runtime_1.jsxs)("div", { className: "flex items-center gap-1", children: [(0, jsx_runtime_1.jsxs)("dt", { className: "text-amber-700", children: [label, ":"] }), (0, jsx_runtime_1.jsx)("dd", { className: "font-semibold", children: value })] }, label))) })] })] }));
};
exports.PreauthAdjustmentBanner = PreauthAdjustmentBanner;
